import { __, any, compose, includes } from 'ramda';

import { flattenGraphQLErrorCodes } from '../graphql/selectors';

const includesRequiresMembershipError = includes(__, [
  'GS_WAYBETTER_MEMBER_ONLY_CODE',
]);

/**
 * Determines if any of the graphql errors contain a requires membership
 * error code.
 *
 * @param {object} graphqlResponse - The graphql response object.
 * @returns {boolean} Whether or not any of the errors contain a requires
 * membership error.
 */
export const hasRequiresMembershipError = compose(
  any(includesRequiresMembershipError),
  flattenGraphQLErrorCodes
);
